import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {BetweenDates, Payment, PaymentMethod, PaymentUpdate} from '../../models/eventRequest';
import {PaymentService} from '../../_services/payment.service';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {DateService} from '../../_services/date.service';
import * as moment from 'moment';
import {Subscription} from 'rxjs';
import {GlobalService} from '../../_services/global.service';
import {ToolsService} from '../../_services/tools.service';

declare let $: any;

@Component({
  selector: 'app-payments-page',
  templateUrl: './payments-page.component.html',
  styleUrls: ['./payments-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentsPageComponent implements OnInit, OnDestroy {

  subscription: Subscription;

  pageNumber = 0;
  pageSize = 100;
  messageError = '';
  periode = '';
  periodeName = 'Cette semaine';
  betweenDates!: BetweenDates;
  sortField = 'invoiceNumber';
  sortDirection = 'DESC';
  paymentMethodFilter: string | null = null;

  payments: Payment[] = [];
  allPayments: Payment[] = [];
  pagePayment: any;
  totalPaymentDetails: any;
  paymentMethods: PaymentMethod[] = [
    { id: 1 as any, name: 'ESPECE', description: 'Paiement en espèces' },
    { id: 2 as any, name: 'CB', description: 'Paiement par carte bancaire' },
    { id: 3 as any, name: 'VIREMENT', description: 'Paiement par virement' },
    { id: 4 as any, name: 'CHEQUE', description: 'Paiement par chèque' }
  ];

  showDisabledPaymentPopup = false;
  paymentToUpdate: PaymentUpdate | undefined = undefined;
  paymentToDisabled: bigint | null = null;

  showResetInvoicePopup = false;
  resetInvoiceYear: number | null = new Date().getFullYear();
  resetInvoiceMessage = '';
  resetInvoiceSuccess = false;
  resetInvoiceLoading = false;

  isRefundMode = false;
  selectedStudent: any = null;

  userRoles: any[] = [];
  readonly invoiceYears = this.buildInvoiceYears();

  calendarForm = this.fb.group({
    startDate: [new Date(), Validators.required],
    endDate: [new Date(), Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    public paymentService: PaymentService,
    private router: Router,
    private dateService: DateService,
    private cdr: ChangeDetectorRef,
    private globalService: GlobalService,
    private toolsService: ToolsService
  ) {
    this.betweenDates = this.dateService.getCurrentWeekBoundaries();
    const { start, end } = this.dateService.getWeekBoundaries(new Date());
    this.calendarForm = this.fb.group({
      startDate: [start, Validators.required],
      endDate: [end, Validators.required],
    });
    this.subscription = new Subscription();

    // Récupérer les rôles de l'utilisateur
    this.toolsService.getUserRoles().subscribe(
      (data: any) => {
        this.userRoles = data;
      },
      err => {
        console.error('Error fetching user roles:', err);
      }
    );
  }

  ngOnInit(): void {
    this.betweenDates = this.dateService.getCurrentWeekBoundaries();
    this.updatePeriode(this.betweenDates);
    this.getPayments(this.betweenDates);
    this.subscription = this.globalService.paymentAdded$.subscribe(
      (added: boolean) => {
        if (added) {
          this.getPayments(this.betweenDates);
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getPayments(betweenDates: BetweenDates): void {
    const sort = `${this.sortField},${this.sortDirection}`;
    this.paymentService.getPaymentsBetweenDates(betweenDates, this.pageNumber, this.pageSize, sort).subscribe(
      pageable => {
        this.pagePayment = pageable;
        this.allPayments = pageable.content;
        this.applyPaymentMethodFilter();
        this.getTotalPaymentDetails(betweenDates);
        this.cdr.detectChanges();
      },
      error => {
        console.error('Error fetching payments:', error);
        this.messageError = 'Erreur lors de la récupération des paiements.';
        this.cdr.detectChanges();
      }
    );
  }

  getTotalPaymentDetails(betweenDates: BetweenDates): void {
    this.paymentService.getTotalGroupByPaymentsBetweenDates(betweenDates).subscribe(
      data => {
        this.totalPaymentDetails = data;
        this.cdr.detectChanges();
      },
      error => {
        console.error('Error fetching payment details:', error);
      }
    );
  }

  onChangePaymentPage($event: number): void {
    this.pageNumber = $event;
    this.getPayments(this.betweenDates);
  }

  onChangePeriode(periode: string): void {
    switch (periode) {
      case 'today':
        this.periodeName = 'Aujourd\'hui';
        this.betweenDates = this.dateService.getDayBoundaries();
        break;
      case 'week':
        this.periodeName = 'Cette Semaine';
        this.betweenDates = this.dateService.getCurrentWeekBoundaries();
        break;
      case 'lastWeek':
        this.periodeName = 'La Semaine Dernière';
        this.betweenDates = this.dateService.getLastWeekBoundaries();
        break;
      case 'month':
        this.periodeName = 'Ce Mois ci';
        this.betweenDates = this.dateService.getCurrentMonthBoundaries();
        break;
      default:
        console.error('Unknown period:', periode);
        return;
    }
    this.pageNumber = 0;
    this.updatePeriode(this.betweenDates);
    this.getPayments(this.betweenDates);
  }

  updatePeriode(betweenDates: BetweenDates): void {
    this.periode = `DU ${moment(betweenDates.startAt).format('DD/MM/YYYY')} AU ${moment(betweenDates.endAt).format('DD/MM/YYYY')}`;
  }

  openCalendarForm(): void {
    $('#calendarModal').modal('show');
  }

  isSubmited(form: any): void {
    if (form.valid) {
      const startDate = this.calendarForm.get('startDate')?.value;
      const endDate = this.calendarForm.get('endDate')?.value;
      if (startDate && endDate) {
        this.betweenDates = new BetweenDates(startDate, endDate);
        this.pageNumber = 0;
        this.getPayments(this.betweenDates);
        this.updatePeriode(this.betweenDates);
        $('#calendarModal').modal('hide');
      } else {
        console.error('Les dates ne sont pas définies');
      }
    } else {
      console.error('Le formulaire n\'est pas valide');
    }
  }

  onPaymentToUpdate(payment: Payment): void {
    // Convertir Payment en PaymentUpdate
    this.paymentToUpdate = new PaymentUpdate(
      payment.paymentId,
      payment.invoiceNumber,
      payment.date,
      payment.amount,
      payment.paymentMethod,
      payment.description
    );
    $('#updatePaymentModal').modal('show');
  }

  onPaymentDisabled(paymentId: bigint): void {
    this.paymentToDisabled = paymentId;
    this.showDisabledPaymentPopup = true;
  }

  onPaymentRefund(payment: Payment): void {
    // Pour l'instant, on ne fait rien avec le paiement spécifique
    // On ouvre juste le formulaire en mode remboursement
    this.onOpenRefundForm();
  }

  onOpenRefundForm(): void {
    // Ouvrir le modal de paiement en mode remboursement
    $('#newPaymentModal').modal('show');
  }

  closeUpdatePaymentPopup(): void {
    this.paymentToUpdate = undefined;
    this.getPayments(this.betweenDates);
  }

  closeDisabledPaymentPopup(): void {
    this.showDisabledPaymentPopup = false;
    this.paymentToDisabled = null;
  }

  confirmDisablePayment(): void {
    if (this.paymentToDisabled) {
      this.paymentService.disabledPayment(Number(this.paymentToDisabled)).subscribe(
        () => {
          this.closeDisabledPaymentPopup();
          this.getPayments(this.betweenDates);
        },
        error => {
          console.error('Error disabling payment:', error);
          this.messageError = 'Erreur lors de la suppression du paiement.';
          this.cdr.detectChanges();
        }
      );
    }
  }

  onChangeSortBy(sortBy: string): void {
    // Si on clique sur le même champ, on inverse la direction
    if (this.sortField === sortBy) {
      this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      // Si on change de champ, on commence par DESC
      this.sortField = sortBy;
      this.sortDirection = 'DESC';
    }
    this.pageNumber = 0;
    this.getPayments(this.betweenDates);
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) {
      return 'fa-sort';
    }
    return this.sortDirection === 'ASC' ? 'fa-sort-asc' : 'fa-sort-desc';
  }

  onFilterByPaymentMethod(method: string | null): void {
    this.paymentMethodFilter = method;
    this.applyPaymentMethodFilter();
  }

  applyPaymentMethodFilter(): void {
    if (this.paymentMethodFilter === null) {
      this.payments = this.allPayments;
    } else {
      this.payments = this.allPayments.filter(payment => payment.paymentMethod === this.paymentMethodFilter);
    }
    this.cdr.detectChanges();
  }

  isFilterActive(method: string | null): boolean {
    return this.paymentMethodFilter === method;
  }

  openResetInvoicePopup(): void {
    this.resetInvoiceYear = new Date().getFullYear();
    this.resetInvoiceMessage = '';
    this.resetInvoiceSuccess = false;
    this.resetInvoiceLoading = false;
    this.showResetInvoicePopup = true;
  }

  closeResetInvoicePopup(): void {
    this.showResetInvoicePopup = false;
    this.resetInvoiceMessage = '';
    this.resetInvoiceSuccess = false;
    this.resetInvoiceLoading = false;
  }

  confirmResetInvoiceNumbers(): void {
    this.resetInvoiceMessage = '';
    this.resetInvoiceSuccess = false;
    this.resetInvoiceLoading = true;

    this.paymentService.resetInvoiceNumbers(this.resetInvoiceYear ?? undefined).subscribe(
      (response) => {
        this.resetInvoiceLoading = false;
        this.resetInvoiceSuccess = true;
        const updated = response.updated || 0;
        const range = response.range || '';
        const targetYear = this.resetInvoiceYear ? `pour l'année ${this.resetInvoiceYear}` : 'pour toutes les années';
        this.resetInvoiceMessage = `✓ Réinitialisation réussie : ${updated} facture(s) renumérotée(s) ${targetYear}.${range ? ` (${range})` : ''}`;
        this.cdr.detectChanges();

        setTimeout(() => {
          this.getPayments(this.betweenDates);
          this.closeResetInvoicePopup();
        }, 2000);
      },
      (error) => {
        this.resetInvoiceLoading = false;
        this.resetInvoiceSuccess = false;
        this.resetInvoiceMessage = '✗ Erreur lors de la réinitialisation des numéros de facture : ' +
          (error.error?.message || 'Erreur inconnue');
        this.cdr.detectChanges();
      }
    );
  }

  onResetYearChange(year: string): void {
    this.resetInvoiceYear = year ? Number(year) : null;
  }

  isSuperAdmin(): boolean {
    return this.userRoles.indexOf('ROLE_SUPER_ADMIN') > -1;
  }

  private buildInvoiceYears(): number[] {
    const currentYear = new Date().getFullYear();
    return Array.from({length: 8}, (_, index) => currentYear - 4 + index);
  }
}
